(function () {
	!(function () {
		const drugData = [
			{
				name: 'Alcohol',
				tableData: [
					{
						title: 'Drug',
						data: ['Over the counter', 'depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Over the counter',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit (Scotland) - 50mg per 100ml of blood. Legal limit (rest of the UK) - 80mg per 100ml of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'Alcohol slows down your reactions and impacts your coordination. Alcohol can also lower your inhibitions and cause more reckless driving behaviour. At higher doses, alcohol can impair your vision',
					},
				],
			},
			{
				name: 'Cetirizine',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Over the counter',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - none',
					},
					{
						title: 'Impact on driving ability',
						data: 'A non-drowsy antihistamine, cetirizine is used to treat hay fever symptoms. Some common side effects include tiredness and feeling agitated, which could impact your driving ability',
					},
				],
			},
			{
				name: 'Clonazepam',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'legal limit - 50 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'An anti-anxiety medication that lists drowsiness and a loss of coordination among its side effects, which could impact your ability to drive.',
					},
				],
			},
			{
				name: 'Caffeine',
				tableData: [
					{
						title: 'Drug',
						data: ['Over the counter', 'Stimulant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Over the counter',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - none',
					},
					{
						title: 'Impact on driving ability',
						data: 'Caffeine increases your heart rate and blood pressure, giving you a boost to your attention and fighting off drowsiness. In larger doses it can cause a lack of concentration, irritability and aggression.',
					},
				],
			}, // {
			//     "name": 'Cannabis',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Depressant'], },
			//         { "title": "Legal status", "data": "Illegal - Class B", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit â€“ 2 microgrammes per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "Cannabis slows down your reaction times and alters your perception of distance. Youâ€™re also more likely to become distracted and drowsy at the wheel.", },
			//     ]
			// },
			// {
			//     "name": 'Cocaine',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Stimulant'], },
			//         { "title": "Legal status", "data": "Illegal - Class A", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit â€“ 10 microgrammes per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "Cocaine can cause an enhanced feeling of confidence, as well as aggressive and reckless behaviour. Although it creates a sensation of alertness, your physical reactions may become impaired.", },
			//     ]
			// },
			{
				name: 'Diazepam',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'legal limit - 550 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'An anti-anxiety medication that lists drowsiness, confusion and loss of coordination among its side effects, which could impact your ability to drive.',
					},
				],
			},
			{
				name: 'Drowsy antihistamines',
				tableData: [
					{
						title: 'Drug',
						data: ['Over the counter', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'legal limit - 550 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'Whereas non-drowsy hay fever medications are available over the counter, drugs such as chlorphenamine, hydroxyzine and promethazine are prescription only because they can cause drowsiness. This could lead to delayed reaction times and inattentiveness at the wheel.',
					},
				],
			}, // {
			//     "name": 'Heroin',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Depressant'], },
			//         { "title": "Legal status", "data": "Illegal - Class A", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit - 5 microgrammes per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "Heroin slows down your heart rate and breathing, creating a sense of relaxation. It also impairs your ability to think clearly and increases the likelihood of confusion.", },
			//     ]
			// },
			// {
			//     "name": 'Ketamine',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Hallucinogen'], },
			//         { "title": "Legal status", "data": "Illegal - Class B", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit - 20 microgrammes per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "Ketamin can cause hallucinations, which may result in reacting to things that aren't actually there. Ketamine can also cause agitation and damage your memory", },
			//     ]
			// },
			{
				name: 'Lorazepam',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - 100 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'An anti-anxiety medication that lists drowsiness and loss of coordination among its side effects, which could impact your ability to drive.',
					},
				],
			}, // {
			//     "name": 'LSD',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Hallucinogen'], },
			//         { "title": "Legal status", "data": "Illegal - Class A", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit - 1 microgramme per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "LSD, aka acid, causes strong hallucinations, often leading you to see and hear things that aren't there. LSD also distorts your perception of time, which increases the risk of speeding and poor reaction times.", },
			//     ]
			// },
			// {
			//     "name": 'MDMA',
			//     "tableData": [
			//         { "title": "Drug", "data": ['Illegal', 'Stimulant'], },
			//         { "title": "Legal status", "data": "Illegal - Class A", },
			//         { "title": "Driving limit", "data": "Accidental exposure limit - 10 microgrammes per litre of blood", },
			//         { "title": "Impact on driving ability", "data": "MDMA, aka ecstasy, causes your heart rate to increase, often giving you a boost of energy. A dangerously high increase in body temperature, known as hyperthermia, or heatstroke, is the most common health problem. It can also lower your inhibitions, which could lead to reckless driving behaviour", },
			//     ]
			// },
			{
				name: 'Methadone',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - 500 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'A strong painkiller and also a stepping stone from weaning off heroin, methadone slows down certain bodily functions, causeing drowsiness and impaired mental functions',
					},
				],
			},
			{
				name: 'Morphine',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'Accidental exposure limit - 80 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'Morphine is a strong prescription painkiller that shares many effects with heroin - lower concentration, drowsiness and feelings of relaxation.',
					},
				],
			},
			{
				name: 'Naproxen',
				tableData: [
					{
						title: 'Drug',
						data: ['Over the counter', 'Painkiller'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Over the counter',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - none',
					},
					{
						title: 'Impact on driving ability',
						data: 'An anti-inflammatory medication commonly used to relieve period pain, naproxen lists confusion, headaches and impaired vision among its side effects.',
					},
				],
			},
			{
				name: 'Nicotine',
				tableData: [
					{
						title: 'Drug',
						data: ['Over the counter', 'Stimulant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Over the counter',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - none',
					},
					{
						title: 'Impact on driving ability',
						data: 'Although nicotine has no direct impact on your driving ability, the act of smoking or vaping while driving can cause distraction behind the wheel.',
					},
				],
			},
			{
				name: 'Oxazepam',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - 300 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'A tranquiliser that is used to treat anxiety and insomnia, Oxapezam lists dizziness and drowsiness among its side effects. It can also impair your judgement and reaction times.',
					},
				],
			},
			{
				name: 'Temazepam',
				tableData: [
					{
						title: 'Drug',
						data: ['Prescription', 'Depressant'],
					},
					{
						title: 'Legal status',
						data: 'Legal - Prescription',
					},
					{
						title: 'Driving limit',
						data: 'Legal limit - 1,000 microgrammes per litre of blood',
					},
					{
						title: 'Impact on driving ability',
						data: 'A tranquiliser that is used to treat insomnia, Temazepam can cause drowsiness, blurred vision and impaired concentration.',
					},
				],
			},
		];
		const tableContainer = document.getElementById('drug-results-table-container');
		const table = document.getElementById('drug-results-table-container').getElementsByTagName('table')[0];
		const form = document.getElementById('drug-form');
		const continueButton = document.getElementById('choose-drug');
		const select = document.getElementById('drug-selector');
		const validation = document.getElementById('drug-driving-validation-text');

		resetResultsTable = function resetResultsTable() {
			table.innerHTML = '';
			tableContainer.style.display = 'none';
			form.style.display = 'block';
			select.selectedIndex = 0;
		};

		showResultsTable = function showResultsTable() {
			if (table.innerHTML !== '') {
				tableContainer.style.display = 'block';
				form.style.display = 'none';
			}
		};

		createResultsTable = function createResultsTable(name) {
			validation.style.display = 'none';
			table.innerHTML = '';
			var drug = drugData.filter(function (drug) {
				return drug.name == name;
			});
			var drug = drug.pop();
			drug.tableData.forEach(function (item) {
				const row = document.createElement('tr');
				const rowHead = document.createElement('th');
				const rowData = document.createElement('td');

				if (Array.isArray(item['data'])) {
					const rowHeadText = document.createTextNode(item.title);
					rowHead.appendChild(rowHeadText);
					const drugName = document.createElement('h5');
					drugName.innerHTML = drug.name;
					rowData.appendChild(drugName);
					const list = document.createElement('ul');
					item.data.forEach(function (data) {
						const listItem = document.createElement('li');
						const textContent = document.createElement('span');
						textContent.innerHTML = data;
						listItem.appendChild(textContent);
						list.appendChild(listItem);
					});
					rowData.appendChild(list);
				} else {
					const _rowHeadText = document.createTextNode(item.title);

					const rowDataText = document.createTextNode(item.data);
					rowHead.appendChild(_rowHeadText);
					rowData.appendChild(rowDataText);
				}

				row.appendChild(rowHead);
				row.appendChild(rowData);
				table.appendChild(row);
			});
		};

		continueButtonClicked = function continueButtonClicked() {
			if (select.selectedIndex == 0) {
				validation.style.display = 'flex';
			} else {
				showResultsTable();
			}
		};

		document.addEventListener('DOMContentLoaded', function () {
			const resetButton = document.getElementById('reset-button');

			select.onchange = function (e) {
				createResultsTable(e.target.value);
			};

			continueButton.onclick = function (e) {
				continueButtonClicked();
			};

			resetButton.onclick = function (e) {
				resetResultsTable();
			};

			drugData.forEach(function (drug) {
				const option = document.createElement('option');
				option.value = drug.name;
				const textNode = document.createTextNode(drug.name);
				select.appendChild(option).appendChild(textNode);
			});
		});
	})();
})();
